import ModalAddEditTextbinReplacement from "./modal-add-edit-textbin-replacement";

export default ModalAddEditTextbinReplacement;